export const SUPPORTED_LOCALES = [
  { code: 'en-US', urlCode: 'us', name: 'English (US)', flagCode: 'us', country: 'United States', shippingCountryCode: 'US', hreflang: 'en-US' },
  { code: 'en-GB', urlCode: 'uk', name: 'English (UK)', flagCode: 'gb', country: 'United Kingdom', shippingCountryCode: 'GB', hreflang: 'en-GB' },
  { code: 'fr-FR', urlCode: 'fr', name: 'Français (France)', flagCode: 'fr', country: 'France', shippingCountryCode: 'FR', hreflang: 'fr-FR' },
  { code: 'es-ES', urlCode: 'es', name: 'Español (España)', flagCode: 'es', country: 'Spain', shippingCountryCode: 'ES', hreflang: 'es-ES' },
  { code: 'de-DE', urlCode: 'de', name: 'Deutsch (Deutschland)', flagCode: 'de', country: 'Germany', shippingCountryCode: 'DE', hreflang: 'de-DE' },
  { code: 'it-IT', urlCode: 'it', name: 'Italiano (Italia)', flagCode: 'it', country: 'Italy', shippingCountryCode: 'IT', hreflang: 'it-IT' },
  { code: 'pt-PT', urlCode: 'pt', name: 'Português (Portugal)', flagCode: 'pt', country: 'Portugal', shippingCountryCode: 'PT', hreflang: 'pt-PT' },
  { code: 'nl-NL', urlCode: 'nl', name: 'Nederlands (Nederland)', flagCode: 'nl', country: 'Netherlands', shippingCountryCode: 'NL', hreflang: 'nl-NL' },
  { code: 'es-CO', urlCode: 'co', name: 'Español (Colombia)', flagCode: 'co', country: 'Colombia', shippingCountryCode: 'CO', hreflang: 'es-CO' },
  { code: 'es-AR', urlCode: 'ar', name: 'Español (Argentina)', flagCode: 'ar', country: 'Argentina', shippingCountryCode: 'AR', hreflang: 'es-AR' },
  { code: 'es-MX', urlCode: 'mx', name: 'Español (México)', flagCode: 'mx', country: 'Mexico', shippingCountryCode: 'MX', hreflang: 'es-MX' },
  { code: 'en-AU', urlCode: 'au', name: 'English (Australia)', flagCode: 'au', country: 'Australia', shippingCountryCode: 'AU', hreflang: 'en-AU' },
  { code: 'en-CA', urlCode: 'ca', name: 'English (Canada)', flagCode: 'ca', country: 'Canada', shippingCountryCode: 'CA', hreflang: 'en-CA' },
];

export const DEFAULT_LOCALE = 'en-US';
export const SUPPORTED_LOCALE_CODES = SUPPORTED_LOCALES.map((l) => l.code);

export function normalizeLocale(raw) {
  const v = String(raw || '').trim().replace('_', '-');
  if (!v) return DEFAULT_LOCALE;
  const exact = SUPPORTED_LOCALES.find((l) => l.code === v);
  if (exact) return exact.code;
  const lower = v.toLowerCase();
  const hit = SUPPORTED_LOCALES.find((l) => l.code.toLowerCase() === lower);
  return hit ? hit.code : DEFAULT_LOCALE;
}

export const getLocaleByCode = (code) =>
  SUPPORTED_LOCALES.find((l) => l.code === normalizeLocale(code)) || SUPPORTED_LOCALES[0];

export const getLocaleByUrlCode = (urlCode) => {
  const lower = String(urlCode || '').trim().toLowerCase();
  return SUPPORTED_LOCALES.find((l) => l.urlCode === lower);
};

